import { useTranslation } from 'react-i18next';

import styles from './TestingBadge.module.scss';

/**
 * Marks a game that is visible only because `can_test_casino_games` is on for this player.
 * Rendered purely off the backend-derived `game.isTestingOnly` — the flag itself is never read here.
 */
export const TestingBadge = () => {
  const { t } = useTranslation();

  // No `title` tooltip — the badge sets `pointer-events: none` so the card underneath stays clickable,
  // which also means it never receives hover.
  return (
    <span aria-label={t('games.openForTesting')} className={styles.testingBadge} data-testid="testing-badge">
      <svg
        className={styles.icon}
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        viewBox="0 0 24 24"
      >
        <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
      </svg>
    </span>
  );
};
